import { call, put, takeLatest } from 'redux-saga/effects';
import HeroUserAPI from 'api-services/HeroUserApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { UNSUBSCRIBE_REQUEST } from './actionTypes';
import { unsubscribeRequestDone, unsubscribeRequestError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* unsubscribe(constAccessParams, action) {
    const { email, account_id, mailing_list } = action.data;
    const result = yield call(HeroUserAPI.unsubscribe, constAccessParams, email, account_id, mailing_list);
    if (isSuccessResponse(result)) {
        yield put(unsubscribeRequestDone());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(unsubscribeRequestError(result));
    }
}
export function* watchUnsubscribeCalls(constAccessParams) {
    yield takeLatest(UNSUBSCRIBE_REQUEST, unsubscribe, constAccessParams);
}
//# sourceMappingURL=saga.js.map